export type ScrollNavigationType = "PUSH" | "REPLACE" | "POP";


// 只在“前进到另一个页面”时回顶：后退要保留原位置，只改 query（如 ?inquiry=1）不能动滚动条。
export function shouldScrollToTop(
  previousPathname: string | null,
  nextPathname: string,
  navigationType: ScrollNavigationType
): boolean {
  if (navigationType === "POP") return false;
  if (previousPathname === null) return false;
  return previousPathname !== nextPathname;
}


/**
 * 从 location.hash 里取出可以用来滚动的元素 id。
 *
 * 客户池行菜单与方案页都用 `#customer-follow-up-workbench` 这类锚点做跨页深链，
 * 以前全仓没有 hash 滚动处理：点「记录跟进」跳过去只落在页顶，窄视口下工作台还在
 * 几屏之后（2026-10-07 审计）。只认像元素 id 的 hash，`#a/b` 这种路由片段不当锚点。
 */
export function hashScrollTarget(hash: string | null | undefined): string | null {
  if (!hash) return null;
  const target = (hash.startsWith("#") ? hash.slice(1) : hash).trim();
  const normalized = target.replace(/^#/, "").trim();
  if (!normalized) return null;
  return /^[A-Za-z][\w:.-]*$/.test(normalized) ? normalized : null;
}
